var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    style: _vm.cssVars
  }, [_c('table', [_vm._t("default", [_vm._m(0), _vm._m(1)])], 2)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("Chore")]), _c('th', [_vm._v("Number of times")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tbody', [_c('tr', [_c('td', [_vm._v("Content")]), _c('td', [_vm._v("Content")])]), _c('tr', [_c('td', [_vm._v("Content")]), _c('td', [_vm._v("Content")])]), _c('tr', [_c('td', [_vm._v("Content")]), _c('td', [_vm._v("Content")])])]);
}]

export { render, staticRenderFns }